/* Medute header interactions — loaded after jQuery */
jQuery(function($) {
  // Mobile header: search icon expands the search form
  $(document).on('click', '.mobile-search-toggle', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $homesearch = $(this).closest('.homesearch');
    var expanded = $homesearch.toggleClass('is-search-expanded').hasClass('is-search-expanded');
    $(this).attr('aria-expanded', expanded ? 'true' : 'false');
    if (expanded) {
      setTimeout(function() {
        $homesearch.find('.mobile-search-form input').focus();
      }, 50);
    }
  });
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.homesearch').length) {
      $('.homesearch').removeClass('is-search-expanded').find('.mobile-search-toggle').attr('aria-expanded', 'false');
    }
  });

  // Desktop Categories dropdown: keyboard/tap toggle
  $(document).on('click', '.cms-menu__categories-toggle', function(e) {
    if (window.innerWidth >= 768) {
      e.preventDefault();
      e.stopPropagation();
      var $cat = $(this).closest('.cms-menu__categories');
      var isOpen = $cat.toggleClass('is-open').hasClass('is-open');
      $(this).attr('aria-expanded', isOpen ? 'true' : 'false');
    }
  });
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.cms-menu__categories').length) {
      $('.cms-menu__categories').removeClass('is-open').find('.cms-menu__categories-toggle').attr('aria-expanded', 'false');
    }
  });

  // Mobile secondary menu (cms-menu) scroll arrows + fade
  $('.cms-menu__inner').each(function() {
    var $inner = $(this);
    var $scroll = $inner.closest('.cms-menu__scroll');
    var $left = $scroll.find('.cms-menu__arrow--left');
    var $right = $scroll.find('.cms-menu__arrow--right');
    var $fade = $scroll.find('.cms-menu__fade--right');

    function updateControls() {
      var scrollLeft = $inner.scrollLeft();
      var maxScroll = $inner[0].scrollWidth - $inner.outerWidth();
      var overflow = maxScroll > 2;
      $scroll.toggleClass('cms-menu__scroll--overflow', overflow);
      $left.toggleClass('is-hidden', scrollLeft <= 2 || !overflow);
      $right.toggleClass('is-hidden', scrollLeft >= maxScroll - 2 || !overflow);
      $fade.toggleClass('is-hidden', scrollLeft >= maxScroll - 2 || !overflow);
    }

    $left.on('click', function() { $inner.animate({scrollLeft: $inner.scrollLeft() - 150}, 200); });
    $right.on('click', function() { $inner.animate({scrollLeft: $inner.scrollLeft() + 150}, 200); });
    $inner.on('scroll', updateControls);
    $(window).on('resize', updateControls);
    updateControls();
  });

  // Sticky header class
  $(window).scroll(function () {
    if ($(this).scrollTop() > 80) {
      $('.headernav').addClass('is-sticky');
    } else {
      $('.headernav').removeClass('is-sticky');
    }
  });

  // Cart page only: +/- quantity buttons (do not hijack product PDP .qtyplus/.qtyminus)
  $(document).on('click', '.cartqty .qtyplus, .medute-qty--cart .qtyplus', function(e) {
    e.preventDefault();
    var $input = $(this).closest('.cartqty, .medute-qty--cart').find('input[name="updates[]"]');
    if (!$input.length) return;
    var currentVal = parseInt($input.val(), 10);
    $input.val(!isNaN(currentVal) ? currentVal + 1 : 1);
  });
  $(document).on('click', '.cartqty .qtyminus, .medute-qty--cart .qtyminus', function(e) {
    e.preventDefault();
    var $input = $(this).closest('.cartqty, .medute-qty--cart').find('input[name="updates[]"]');
    if (!$input.length) return;
    var currentVal = parseInt($input.val(), 10);
    $input.val(!isNaN(currentVal) && currentVal > 1 ? currentVal - 1 : 1);
  });
});
